module.exports = __webpack_public_path__ + "9bb9e40673b72d86c71b0de6d2a9396a.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/charlie-gerard.jpg
// module id = 509
// module chunks = 0